export default "__VITE_ASSET__1fb6282a__"